var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabTest1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79552 0C6.20311 0 4.10156 2.10154 4.10156 4.69393C4.10156 7.2863 6.20311 9.38782 8.79552 9.38782C11.3879 9.38782 13.4894 7.2863 13.4894 4.69393C13.4894 2.10154 11.3879 0 8.79552 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.435 10.0817C16.0005 9.58947 15.3627 9.27734 14.6528 9.27734H12.9468C11.6343 9.27734 10.5703 10.3414 10.5703 11.6539V17.6248C10.5703 18.9374 11.6343 20.0013 12.9468 20.0013H14.6528C15.3627 20.0013 16.0005 19.6892 16.435 19.1969C16.6801 18.9193 16.6536 18.4955 16.376 18.2504C16.0983 18.0054 15.6746 18.0318 15.4296 18.3094C15.2388 18.5255 14.9619 18.6602 14.6528 18.6602H12.9468C12.375 18.6602 11.9114 18.1966 11.9114 17.6248V11.6539C11.9114 11.082 12.375 10.6185 12.9468 10.6185H14.6528C14.9619 10.6185 15.2388 10.7531 15.4296 10.9692C15.6746 11.2468 16.0983 11.2733 16.376 11.0282C16.6536 10.7832 16.6801 10.3594 16.435 10.0817Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9798 14.1652C19.2417 14.427 19.2417 14.8515 18.9798 15.1134L17.1916 16.9016C16.9298 17.1635 16.5052 17.1635 16.2433 16.9016C15.9814 16.6397 15.9814 16.2152 16.2433 15.9533L18.0314 14.1652C18.2933 13.9033 18.7179 13.9033 18.9798 14.1652Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9798 15.1125C19.2417 14.8506 19.2417 14.4261 18.9798 14.1643L17.1916 12.3761C16.9298 12.1142 16.5052 12.1142 16.2433 12.3761C15.9814 12.638 15.9814 13.0625 16.2433 13.3244L18.0314 15.1125C18.2933 15.3744 18.7179 15.3744 18.9798 15.1125Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9141 14.6393C12.9141 14.269 13.2142 13.9688 13.5846 13.9688H18.055C18.4254 13.9688 18.7256 14.269 18.7256 14.6393C18.7256 15.0096 18.4254 15.3099 18.055 15.3099H13.5846C13.2142 15.3099 12.9141 15.0096 12.9141 14.6393Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24076 11.3323C9.23172 11.4378 9.22717 11.5446 9.22717 11.6524V17.6233C9.22717 18.2901 9.40267 18.9158 9.71006 19.4569H1.56464C0.700521 19.4569 0 18.7564 0 17.8923V14.6093C0 14.0611 0.302548 13.5578 0.786595 13.3006C3.42472 11.8986 6.34164 11.2426 9.24076 11.3323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest1);
export default __webpack_public_path__ + "static/media/lab-test-1.f90b74924b5612b9a9670202dfb7a0b9.svg";
export { ForwardRef as ReactComponent };